import createVueComponent from '../createVueComponent';

const ChevronUpCircle = createVueComponent('ChevronUpCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'm8 14 4-4 4 4', key: 'fy2ptz' }],
]);

export default ChevronUpCircle;
